import React from 'react'

import { Box, Button } from '@material-ui/core'
import { Link } from 'gatsby-plugin-intl'

import CityCare from '~/assets/navigation-icons/city_care.svg'
import Pricing from '~/assets/navigation-icons/pricing_icon.svg'
import Setup from '~/assets/navigation-icons/setup.svg'
import Support from '~/assets/navigation-icons/support.svg'
import { Links } from '~/constants/links'
import '~/styles/custom/menuCities.scss'
import translate from '~/locale'

export default function MenuCities(props) {
  return (
    <>
      <Box className="overflow-hidden border-0 bg-midnight-bloom p-3 dropdown-mega-menu-md">
        <div className="text-center">
          <div className="font-weight-bold font-size-xl mb-1 text-white">
            {translate('featuresandbenefits')}
          </div>
          <p className="text-white-50 mb-3">
            <b className="text-white">{translate('residentsfirst')}</b>
          </p>
        </div>
        <div className="d-flex flex-wrap">
          <div className="w-50 p-2">
            <Button
              to={Links.CITIES_SETUP}
              component={Link}
              className="d-block bg-white p-3 text-primary"
            >
              <div>
                <Setup className="h1 d-block my-2 text-success" />
                <div className="text-black font-weight-bold btn-menu-text">
                  {translate('set_up')}
                </div>
              </div>
            </Button>
          </div>
          <div className="w-50 p-2">
            <Button
              to={Links.CITIES_COACHING}
              component={Link}
              className="d-block bg-white p-3 text-primary"
            >
              <div>
                <Support className="h1 d-block my-2 text-danger" />
                <div className="text-black font-weight-bold btn-menu-text">
                  {translate('coaching')}
                </div>
              </div>
            </Button>
          </div>
          <div className="w-50 p-2">
            <Button
              to={Links.CITIES_CITYCARE}
              component={Link}
              className="d-block bg-white p-3 text-primary"
            >
              <div>
                <CityCare className="h1 d-block my-2 text-warning" />
                <div className="text-black font-weight-bold btn-menu-text">
                  {translate('citycare')}
                </div>
              </div>
            </Button>
          </div>
          <div className="w-50 p-2">
            <Button
              to={Links.CITIES_PRICING}
              component={Link}
              className="d-block bg-white p-3 text-primary"
            >
              <div>
                <Pricing className="h1 d-block my-2 text-first" />
                <div className="text-black font-weight-bold btn-menu-text">
                  {translate('pricing.20')}
                </div>
              </div>
            </Button>
          </div>
        </div>
      </Box>
    </>
  )
}
